import { Component, OnInit } from '@angular/core';
import { TitleService } from 'src/app/shared/services/title.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ClientBillingBackupFileConfigurationService } from 'src/app/shared/api/services';

@Component({
  selector: 'e2cb-data-file-configuration',
  templateUrl: './data-file-configuration.component.html',
  styleUrls: ['./data-file-configuration.component.scss']
})
export class DataFileConfigurationComponent implements OnInit {

    // #region Public Variables
    showSpinner: boolean;
    aggregationResultList: any[] = [];
    public rows: any[] = [];
    // #endregion

    // --------------------------------------------------

    // #region Private Variables
    private _unsortedClientList: any[] = [];
    private _clientConfigList: any[] = [];
    // #endregion

    // --------------------------------------------------

    // #region ReadOnly Variables
    columns: any[] = [
      { name: 'Client Id', prop: 'AviClientId'},
      { name: 'Configuration Type', prop: 'FileType'}
    ];
    rowHeight = 50;
    selected = [];
    // #endregion

    // --------------------------------------------------
  constructor
  (
    private _titleService: TitleService,
    private _clientBackupFileConfigurationService: ClientBillingBackupFileConfigurationService,
  )
  {
    this._titleService.Subtitle = 'Data File Configuration';
  }

  ngOnInit()
  {
    this.PopulateTable();
  }

  handleSelect(event)
  {
    console.log('In HandleSelect().  Not Implemented.');
  }

  // ----------------------------------------------------------
  public async PopulateTable()
  {
    this.showSpinner = true;
    try
    {
      let results = await this._clientBackupFileConfigurationService.GetAllBackupFileConfigurations().toPromise();
      results.forEach(res => {
        if(!isNaN(Number(res.aviClientId)))
        {
          this.rows.push({
            AviClientId: res.aviClientId,
            FileType: res.fileType
            });
        }
      });
    } catch(e)
    {
      this.handleError(e);
    }
  this.rows = [...this.rows];
    this.showSpinner = false;
  }
  // ----------------------------------------------------------
  private handleError(error: any): void
  {
    alert('An error occurred. Please see console log.');
    console.log(error);

    this.showSpinner = false;
  }

}
